// extracted by mini-css-extract-plugin
module.exports = {"container":"Sales_container__3Dink"};